import React, { PureComponent } from 'react'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'

import CollabPanel from './collaborator-panel'
import QueuePanel from './queue-panel'
import SentMessagePanel from './sent-message-panel'
import styles from './styles.css'

class Collaborate extends PureComponent {
  static propTypes = {}

  static defaultProps = {}

  state = {
    defaultTabIndex: 0,
  }

  componentWillMount() {
    if (this.props.location.search) {
      this.setState({
        defaultTabIndex: this.props.location.query.tab - 1,
      })
    }
  }

  render() {
    const { defaultTabIndex } = this.state

    return (
      <Tabs defaultIndex={defaultTabIndex} className={styles.tabContainer}>
        <TabList className={styles.tabList}>
          <Tab
            className={styles.tabHeader}
            selectedClassName={styles.tabSelected}
            disabledClassName={styles.tabDisabled}
          >
            Collaborators
          </Tab>
          <Tab
            className={styles.tabHeader}
            selectedClassName={styles.tabSelected}
            disabledClassName={styles.tabDisabled}
          >
            Queue
          </Tab>
          <Tab
            className={styles.tabHeader}
            selectedClassName={styles.tabSelected}
            disabledClassName={styles.tabDisabled}
          >
            Sent Messages
          </Tab>
        </TabList>
        <div ref={div => (this.divRef = div)} className={styles.tabPanelWrapper}>
          <TabPanel className={styles.tabPanel} selectedClassName={styles.tabPanelSelected}>
            <CollabPanel displayError={this.props.displayError} />
          </TabPanel>
          <TabPanel className={styles.tabPanel} selectedClassName={styles.tabPanelSelected}>
            <QueuePanel />
          </TabPanel>
          <TabPanel className={styles.tabPanel} selectedClassName={styles.tabPanelSelected}>
            <SentMessagePanel />
          </TabPanel>
        </div>
      </Tabs>
    )
  }
}

export default Collaborate



// WEBPACK FOOTER //
// ./src/views/collaborate/index.js